module.exports = __webpack_public_path__ + "img/2.58256a1d.png";